import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import './css/marketing.css';
import { EnvoyeEmail, AfficheEmail, ReEnvoyeEmail, DeleteEmail } from '../../Api/RestaurantApi/MarketingApi';


const Marketing = () => {

    const [show, setShow] = useState(false);
    const [email, setEmail] = useState('');
    const [dataEmail, setDataEmail] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [dataMessage, setDataMessage] = useState([]);

    const [loadReEnvoye, setLoadReEnvoye] = useState(false);

    const [loadDelete, setLoadDelete] = useState(false);

    const [sujet, setSujet] = useState('');
    const [contenu, setContenu] = useState('');

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    let location = useLocation();

    const restaurant = useSelector((state) => state.restaurant);



    useEffect(() => {
        AfficheDataMessage();
    }, []);

    const AfficheDataMessage = () => {
        setLoadData(true);
        AfficheEmail(restaurant.id).then(function (response) {
            console.log("data Message =>", response.data.donner);
            setDataMessage(response.data.donner);
        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadData(false);
        });
    }


    const handleEmail = (e) => {
        e.preventDefault();
        setDataEmail((prev) => [...prev, { id: dataEmail.length + 1, email: email }]);
        setEmail('');
    }

    console.log("Data email", dataEmail);

    const handleDeleteEmail = (id) => {
        setDataEmail(dataEmail.filter((el) => el.id !== id));

    }

    const handleMessage = (e) => {
        e.preventDefault();
        if (!localStorage.getItem('tokenSociete')) {
            setLoading(true);
            const data = { sujet: sujet, message: contenu, idRestaurant: restaurant.id, emails: dataEmail };
            EnvoyeEmail(data).then(function (response) {
                console.log(response);
                if (response.data.title === "success") {
                    toast.success(response.data.message);
                    AfficheDataMessage();
                }
            }).catch(function (error) {
                console.log(error);
                if (error) {
                    toast.error(error.response.data?.message);
                }
            }).finally(function () {
                setLoading(false);
                setSujet('');
                setContenu('');
                setEmail('');
                setDataEmail([]);
                setShow(false)
            });
        } else {
            toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
        }
    }

    const plural = (value) => {
        if (value < 10) {
            return "0" + value;
        } else {
            return value;
        }
    }

    const formatDateMessage = (date) => {
        return plural(new Date(date).getDate()) + "/" + plural(parseInt(new Date(date).getMonth() + 1)) + "/" + new Date(date).getFullYear();
    }

    const handleReEnvoye = (id) => {
        setLoadReEnvoye(true);
        const data = { idMessage: id, idRestaurant: restaurant.id };
        ReEnvoyeEmail(data).then(function (response) {
            console.log(response);
            if (response.data.title === "success") {
                toast.success(response.data.message);
            }
        }).catch(function (error) {
            console.log(error);
            if (error) {
                toast.error(error.response.data?.message);
            }
        }).finally(function () {
            setLoadReEnvoye(false);
        });
    }

    const handleDelete = (id) => {
        setLoadDelete(true);
        DeleteEmail(id).then(function (response) {
            console.log(response);
            if (response.data.title === "success") {
                toast.success(response.data.message);
                AfficheDataMessage();
            }
        }).catch(function (error) {
            console.log(error);
            if (error) {
                toast.error(error.response.data?.message);
            }
        }).finally(function () {
            setLoadDelete(false);
        });
    }

    return (
        <div>
            <Helmet>
                <title>Marketing</title>
                <meta name='description' content='Restaurant Marketing .' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className="marketing">
                <div className='container'>
                    <div className='bloc_marketing'>
                        <div className='marketing_titre'>
                            <div className='d-flex mt-2 titre'>
                                <i className="fa fa-paper-plane-o" aria-hidden="true"></i> <h1>Marketing – E-mailing</h1>
                            </div>
                            <div className='marketing_renseignement'>
                                <div className='d-flex justify-content-between'>
                                    <p>Votre message sera envoyé à tous les clients de cette plateforme et vous pouvez entre autres adresses email.</p>
                                    <button className="btn btn-sm" onClick={handleShow}>Envoye message</button>
                                </div>
                            </div>
                        </div>
                        <div className='marketing_content'>
                            {loadData === true ?
                                <div className="d-flex justify-content-center">
                                    <Spinner animation="border" className="load" variant="info" size="md" />
                                </div>
                                : dataMessage?.length !== 0 ?
                                    <div className='table-responsive'>
                                        <table className="table table-bordered table-striped">
                                            <thead align="center">
                                                <tr>
                                                    <th scope="col">Sujet</th>
                                                    <th scope="col">Message</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Actions</th></tr>
                                            </thead>
                                            <tbody>
                                                {dataMessage.map((el, index) => {
                                                    return (<tr align="center" key={index}>
                                                        <td>{el.sujet}</td>
                                                        <td>{el.message}</td>
                                                        <td>{formatDateMessage(el.createdAt)}</td>
                                                        <td>
                                                            {loadReEnvoye === true ?
                                                                <Spinner animation="border" className="load me-2" variant="info" size="sm" /> :
                                                                <button className='btn btn_reEnvoyer btn-sm me-2' onClick={() => handleReEnvoye(el.id)}>Réenvoyer</button>}

                                                            {loadDelete === true ?
                                                                <Spinner animation="border" className="load ms-2" variant="info" size="sm" /> :
                                                                <button className=' btn btn-danger btn-sm ms-2' onClick={() => handleDelete(el.id)}>Suprimer</button>}
                                                        </td>
                                                    </tr>)
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    : <p>Message partager vide ...</p>}
                            <p className='version'>Version 1</p>
                        </div>

                    </div>
                </div>

            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Body>
                    <div className='marketing_modal'>
                        <div className='marketing_header'>
                            <h2 className='text-center'>Publier votre message</h2>
                        </div>
                        <div className='marketing_body'>
                            <form onSubmit={handleEmail}>
                                <div className='form_email'>
                                    <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="Adresse email..." aria-label="Username" />
                                    <button type="submit" className="btn_email btn" > <i className='fa fa-plus-circle'></i></button>

                                </div>
                            </form>
                            <div className="list_email">
                                {dataEmail.map((el, index) => {
                                    return (<div className="list_item" key={index}>
                                        <span>{el.email}</span>
                                        <span className='fa fa-trash-o' onClick={() => handleDeleteEmail(el.id)}></span>
                                    </div>)
                                })}
                            </div>
                            <form onSubmit={handleMessage}>
                                <div className='message'>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sujet</label>
                                        <input type="text" className="form-control" value={sujet} required onChange={(e) => setSujet(e.target.value)} id="exampleFormControlInput1" placeholder="Sujet ..." />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlTextarea1" className="form-label">Votre message</label>
                                        <textarea className="form-control" value={contenu} required onChange={(e) => setContenu(e.target.value)} id="exampleFormControlTextarea1" rows={3} placeholder="Message ..." />
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <button type='button' className='btn btn-dark' onClick={() => setShow(false)}>Annuler</button>
                                        {loading ? <Button className='btn btn_confirmContact' disabled>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="info"
                                                className="spiner"
                                            />
                                            Chargement...
                                        </Button> : <button type='submit' className='btn btn_send_contact'>Envoyer</button>}


                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Marketing